import styled from 'styled-components';

export const ScheduleItem = styled.div`
    margin-bottom: 20px;
    display: flex;
    background: #fff;
    padding: 32px;
    border-radius: 10px;
    flex-direction: column;
    
    ${(props) => (props.activated ? 'border: 1px solid #EC6E0C;' : 'border: 1px solid #ffffff;')}
`;

export const ScheduleItemContent = styled.div`
    display: flex;
`;

export const ScheduleItemDate = styled.div`
    display: flex;
    flex-direction: column;
    flex: 0.2;

    h1 {
        font-weight: bold;
        padding: 0;
        margin: 0;
        font-family: Oxygen;
        font-size: 18px;
    }

    h2 {
        padding: 0;
        margin: 0;
        font-family: Oxygen;
        font-size: 16px;
    }

    h3 {
        font-weight: bold;
        padding: 0;
        margin: 0;
        font-family: Oxygen;
        font-size: 16px;
    }
`;

export const ScheduleItemInformation = styled.div`
    display: flex;
    justify-content: space-between;
    flex: 0.8;

    h1 {
        margin: 0;
        padding: 0;
        font-size: 12px;
    }
    h2 {
        margin: 0;
        padding: 0;
        font-size: 14px;
    }

    p {
        margin: 0;
        padding: 0;
        font-size: 16px;
    }

    button {
        background: none;
        border: none;
        color: #EC6E0C;
        font-weight: bold;
        text-decoration: underline;
        font-size: 16px;
        cursor: pointer;
    }   
`;

export const ScheduleItemActions = styled.div`
    flex: 0.1;
    display: flex;
    justify-content: center;

    button {
        background: none;
        border: none;
        display: flex;
        cursor: pointer;
    }
`;

export const ScheduleItemFooter = styled.div`
    margin-top: 10px;

    
    hr {
        border-color: #f3f3f3;
    }

    ul {
        display: inline-block;
        margin: 0;
        padding: 10px 0 0 0;
        width: 100%;

        li {
            list-style: none;
            display: inline-flex;
            margin-right: 20px;

            button {
                color: #EC6E0C;
                font-size: 16px;
                font-weight: bold;
                text-decoration: underline;
                display: flex;
                align-items: center;
                background: none;
                border: none;
                cursor: pointer;

                svg {
                    margin-right: 10px;
                }
            }
        }
    }
`;
